import { useWindowSize } from 'react-use'
import { dayjsInit } from '@ow/utils'

export const splitByDay = (list) => {
  const cache = {}
  const setCache = (day, item) => {
    if (cache[day]) {
      cache[day].push(item)
    } else {
      cache[day] = [item]
    }
  }

  list.forEach((paths, index) => {
    paths.forEach((item) => {
      setCache(
        dayjsInit(item.createdAt).format('YYYY-MM-DD') + '-' + index,
        item
      )
    })
  })

  return Object.values(cache).map((collection) => {
    const path = []
    const inspect = []
    const signIn = []

    collection.forEach((item) => {
      const { lng: y, lat: x } = item
      if (!item.scatter) path.push([y, x])
      if (item.isInspect) inspect.push(item)
      if (item.isSignIn) signIn.push(item)
    })
    return {
      path,
      inspect,
      signIn,
    }
  })
}

export const convertTime = (hour) => {
  if (!hour) return null
  hour = Number(hour)
  const minute = hour % 1
  hour = Math.floor(hour)
  return `${hour}时${Math.floor(minute * 60)}分`
}

export const useMobileSize = () => {
  const { width } = useWindowSize()
  return width < 768
}
